export const TYPICAL_BLOCK_HEIGHT = 140;
export const TYPICAL_BLOCK_WIDTH = 140;
export const BLOCK_ADD_BUTTON_HEIGHT = 60;

export const EdgePortTypes = {
  INPUT: 'input',
  OUTPUT: 'output',
};

export const PORT_TYPES = {
  RESPONSE: 'responseStart',
  SUBTRIGGER: 'pseudoBlockOutput',
  SOURCE: 'source',
  TARGET: 'target',
};
